import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Before/after comparison of two pictures (a ":::vergleich" block, see
 * utils/compareBlocks.js). The second picture lies underneath, the first is
 * cut off at the slider's position, so dragging the handle - or the arrow
 * keys, the slider being a real range input - reveals one or the other.
 * `srcFor` resolves a Markdown URL the way the article's pictures are.
 */
function ImageCompare({ images, srcFor }) {
  const { t } = useTranslation();
  const [position, setPosition] = useState(50);
  const [left, right] = images;

  const label = (image) => (image.alt && image.alt !== 'Abbildung' ? image.alt : '');

  return (
    <figure className="image-compare" style={{ '--compare-position': `${position}%` }}>
      <div className="image-compare__stage">
        <img
          className="image-compare__image image-compare__image--right"
          src={srcFor(right.src)}
          alt={label(right)}
          loading="lazy"
          decoding="async"
        />

        <img
          className="image-compare__image image-compare__image--left"
          src={srcFor(left.src)}
          alt={label(left)}
          loading="lazy"
          decoding="async"
        />

        {label(left) && <span className="image-compare__tag image-compare__tag--left">{label(left)}</span>}
        {label(right) && <span className="image-compare__tag image-compare__tag--right">{label(right)}</span>}

        <div className="image-compare__divider" aria-hidden="true">
          <span className="image-compare__handle">
            <i className="fa-solid fa-chevron-left" />
            <i className="fa-solid fa-chevron-right" />
          </span>
        </div>

        <input
          className="image-compare__range"
          type="range"
          min="0"
          max="100"
          step="1"
          value={position}
          onChange={(event) => setPosition(Number(event.target.value))}
          aria-label={t('imageCompare.label', {
            left: label(left) || t('imageCompare.leftFallback'),
            right: label(right) || t('imageCompare.rightFallback'),
          })}
        />
      </div>
    </figure>
  );
}

export default ImageCompare;
